<template>
  <div :id="getAccordionHash()">
    <a
        class="flex w-full justify-between items-center py-4"
        href="#"
        @click.prevent="toggleAccordion()"
        :aria-expanded="isOpen"
    >
            <span class="flex flex-col">
                <slot name="header"></slot>
            </span>

      <span class="flex justify-center items-center w-11 h-11 min-w-11 rounded-full transition-all duration-200"
        :class="`bg-${page_style}-primary hover:bg-${page_style}-tone`">
                <svg
                    class="relative top-px w-4 stroke-dark transition-all duration-200 transform"
                    :class="{
                        'rotate-180': isOpen,
                        'rotate-0': !isOpen,
                    }"
                    fill="none"
                    stroke="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 10"
                    aria-hidden="true"
                >
                    <path
                        d="M15 1.2l-7 7-7-7"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </span>
    </a>

    <div class="border-b border-dotted" :class="page_style ? `border-${page_style}-primary` : 'border-primary'"
    >
      <Transition>
        <div class="py-8" v-show="isOpen">
          <slot />
        </div>
      </Transition>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    let isOpen = false

    if( this.index === '1' ){
        isOpen = this.open_first_row === 'yes'
    }

    return {
      isOpen: isOpen,
    }
  },
  props: {
    group: String,
    name: String,
    page_style: String,
    open_first_row: 'no',
    index: 0,
  },
  created() {
    this.$events.$on(`${this.group}_toggle`, (name) => {
        if (name !== this.name || this.isOpen) {
          this.isOpen = false
        } else {
          this.isOpen = true
        }
    });
  },
  methods: {
    getAccordionHash() {
      if (!this.name) {
        return '';
      }

      return `accordion-${encodeURIComponent(this.name)}`;
    },
    setUrlHash() {
      const hash = this.getAccordionHash();

      if (!hash) {
        return;
      }

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', `#${hash}`);
        return;
      }

      window.location.hash = hash;
    },
    shouldOpenFromHash() {
      const hash = this.getAccordionHash();

      if (!hash) {
        return false;
      }

      return window.location.hash === `#${hash}`;
    },
    handleHashChange() {
      if (this.shouldOpenFromHash() && !this.isOpen) {
        this.$events.$emit(`${this.group}_toggle`, this.name);
      }
    },
    toggleAccordion() {
      const willOpen = !this.isOpen;
      
      this.$events.$emit(`${this.group}_toggle`, this.name);

      if (willOpen) {
        this.setUrlHash();
      }
      
      if (willOpen) {
        setTimeout(() => {
          const accordionHeader = this.$el.querySelector('a');
          
          if (accordionHeader) {
            accordionHeader.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }, 450);
      }
    },
  },
  mounted() {
    window.addEventListener('hashchange', this.handleHashChange);
    if (this.shouldOpenFromHash()) {
      this.$events.$emit(`${this.group}_toggle`, this.name);
    }
  },
  beforeDestroy() {
    window.removeEventListener('hashchange', this.handleHashChange);
  },
};
</script>
<style>
.v-enter-active,
.v-leave-active {
  transition: all 0.4s;
  max-height: 700px;
  overflow: auto;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  max-height: 0px;
}
</style>